var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 389,
    viewBox: "0 0 454 389",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M453.103 243.039C453.103 210.689 433.693 181.574 404.578 168.634C402.96 74.8191 323.703 -1.20337 229.888 0.414127H226.653C131.22 -2.82087 51.9626 71.5841 48.7276 165.399V168.634C8.29012 186.427 -11.1199 233.334 6.67262 275.389C19.6126 304.504 48.7276 323.914 81.0776 323.914C92.4001 323.914 100.488 314.209 100.488 304.504V183.192C100.488 171.869 92.4001 163.782 81.0776 163.782C85.9301 89.3766 150.63 31.1466 225.035 34.3816C301.058 31.1466 364.14 89.3766 370.61 163.782C359.288 163.782 351.2 173.487 351.2 183.192V304.504C351.2 314.209 359.288 323.914 368.993 323.914C365.758 344.942 346.348 357.882 326.938 356.264H302.675C296.205 346.559 286.5 340.089 275.178 340.089H210.478C192.685 340.089 178.128 354.647 178.128 372.439C178.128 390.232 192.685 404.789 210.478 404.789H275.178C286.5 404.789 297.823 398.319 302.675 388.614H326.938C367.375 390.232 401.343 359.499 402.96 319.062V317.444C433.693 304.504 453.103 275.389 453.103 243.039Z",
    fill: "#2E9B72",
    fillOpacity: 0.07
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadset);
export default __webpack_public_path__ + "static/media/headset.1d30dc2781eca11f7026bac66b888d36.svg";
export { ForwardRef as ReactComponent };